import AudioPlayerComponent from './AudioPlayerComponent';
import { graphql } from 'gatsby';

const AudioPlayer = ({ system, audioPlayerElements }: Queries.AUDIO_PLAYERFragment) => {
  const { audio_file, options } = audioPlayerElements;
  const { codename } = system;
  const useBrowserDefault = options?.value?.includes('use_browser_default');
  return (
    <div data-codename={codename}>
      <AudioPlayerComponent url={audio_file.value.url} defaultPlayer={useBrowserDefault} />
    </div>
  );
};

export const fragments = graphql`
  fragment AUDIO_PLAYER on kontent_item_audio_player {
    __typename
    system {
      codename
    }
    audioPlayerElements: elements {
      audio_file {
        value {
          url
        }
      }
      options {
        value
      }
    }
  }
`;

export default AudioPlayer;
